// extracted by mini-css-extract-plugin
export default {"container":"Buttons_container__fTGhu","back":"Buttons_back__JgxCO","next":"Buttons_next__XQ2E0"};